var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
module.exports = x({ ["v4"]: () => (__WEBPACK_EXTERNAL_MODULE_uuid__.v4) });